import { QueryResult } from '@apollo/client';
import {
    OptionCaption,
    OptionCheckbox,
    OptionGhostButton,
    OptionHeader,
    OptionScroller,
    OptionSearch,
    OptionSeparator,
    SelectionOption,
} from '@starryui10/lists/SelectionOption';
import { OptionLoader } from '@starryui10/lists/SelectionOption/OptionLoader';
import React, { useRef } from 'react';
import { IColumnFilterItem, IColumnFilterItemList, IColumnFilterVariables } from '../../graphql/useColumnFilter';
import { strings } from '../../localization';

interface ICheckBoxColumnFilterProps {
    displayName: string;
    field: string;
    queryName: string;
    useColumnFilter: (variables: IColumnFilterVariables) => QueryResult<IColumnFilterItemList, IColumnFilterVariables>;
}

export const CheckBoxColumnFilter = ({ displayName, queryName, useColumnFilter }: ICheckBoxColumnFilterProps) => {
    const searchFor = useRef<string>('');
    const { data, loading, refetch } = useColumnFilter({
        skip: 0,
        limit: 0,
        sort: [{ field: 'DESCRIPTION', order: 'ASC' }],
    });

    if (!useColumnFilter) {
        return <></>;
    }

    const handleSearch = (search: string) => {
        searchFor.current = search;
        refetch({ filter: [{ search: { like: search } }] });
        return Promise.resolve();
    };

    const handelOnClick = () => {
        // update filter
    };

    const handelClearFilter = () => {
        // clear filter
    };

    return loading ? (
        <OptionLoader />
    ) : (
        <SelectionOption focusFirstElement selector="li > button, input[type='search']">
            <OptionHeader caption={`${strings.ColumnFilter_Label_Search} ${displayName}`} />
            <OptionSeparator />
            <OptionSearch onSearchChange={handleSearch} />

            <OptionScroller maxHeight="200px">
                {data?.[queryName]?.nodes && data?.[queryName]?.nodes?.length > 0 ? (
                    data?.[queryName]?.nodes?.map((item: IColumnFilterItem) => (
                        <OptionCheckbox
                            key={item.id}
                            onClick={handelOnClick}
                            highlight={searchFor.current}
                            variant="control"
                            caption={item.description}
                            checked={false}
                        />
                    ))
                ) : (
                    <OptionCaption caption={strings.CheckboxColumnFilter_Label_NoResultsFound} />
                )}
            </OptionScroller>

            <OptionSeparator />
            <OptionGhostButton caption={strings.CheckboxColumnFilter_Action_ClearFilter} onClick={handelClearFilter} />
        </SelectionOption>
    );
};
